import { render, staticRenderFns } from "./AclUsuario.vue?vue&type=template&id=326d4b72&scoped=true&"
import script from "./AclUsuario.vue?vue&type=script&lang=js&"
export * from "./AclUsuario.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "326d4b72",
  null
  
)

export default component.exports